import {Inject, Injectable} from '@angular/core';
import {ConfigService} from '../../config/config.service';
import {Language} from '../../config/model/app-config.model';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private _map_extent_storage_key = 'MAP_EXTENT';
  private _widgetIds_storage_key = 'WIDGET_IDS';
  private _language_storage_key = 'LANG';

  constructor(
    @Inject(ConfigService) private _configService: ConfigService,
    @Inject(LOCAL_STORAGE) private _storageService: StorageService
  ) {
    // create unique local storage keys
    this._map_extent_storage_key = this._configService.appConfig.storageKeyPrefix + this._map_extent_storage_key;
    this._widgetIds_storage_key = this._configService.appConfig.storageKeyPrefix + this._widgetIds_storage_key;
    this._language_storage_key = this._configService.appConfig.storageKeyPrefix + this._language_storage_key;
  }

  public get extent(): __esri.Extent {
    return this.getData(this._map_extent_storage_key);
  }

  public set extent(extent: __esri.Extent) {
    if (extent) {
      this.storeData(this._map_extent_storage_key, extent.toJSON());
    }
  }

  public get language(): Language {
    return this.getData(this._language_storage_key);
  }

  public set language(lang: Language) {
    this.storeData(this._language_storage_key, lang);
  }

  public get widgetIds(): string[] {
    return this.getData(this._widgetIds_storage_key);
  }

  public set widgetId(widgetId: string) {
    let storedIds = this.widgetIds;
    if (!storedIds) {
      storedIds = [];
    }

    const idExists = storedIds.filter(currentID => currentID === widgetId);

    if (idExists.length !== 1) {
      storedIds.push(widgetId);
    }

    this.storeData(this._widgetIds_storage_key, storedIds);
  }

  public removeWidgetId(widgetId: string) {
    const storedIds = this.widgetIds;
    if (!storedIds) return;

    const widgetIdIndex = storedIds.indexOf(widgetId);
    storedIds.splice(widgetIdIndex, 1);

    this.storeData(this._widgetIds_storage_key, storedIds);
  }

  private getData(name: string): any {
    const data = this._storageService.get(name);
    if (data) {
      return JSON.parse(data);
    }
    return undefined;
  }

  private storeData(name: string, valueJson: any) {
    const valueString = JSON.stringify(valueJson);
    this._storageService.set(name, valueString);
  }
}
